import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from '../api/client';

function onAuthError(error: unknown) {
  // A lost session sends the user back to sign-in (except on the auth pages themselves).
  if (
    error instanceof ApiError &&
    (error.code === 'UNAUTHENTICATED' || error.code === 'AUTH_MFA_PENDING')
  ) {
    void queryClient.invalidateQueries({ queryKey: ['session'] });
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: onAuthError }),
  mutationCache: new MutationCache({ onError: onAuthError }),
  defaultOptions: {
    queries: {
      retry: (count, error) =>
        !(error instanceof ApiError && error.status >= 400 && error.status < 500) && count < 2,
      refetchOnWindowFocus: false,
      staleTime: 15_000,
    },
  },
});
